import TerritoryMasterReport from '@/pages/Territory/TerritoryReport/TerritoryReport';
import ViewTerritory from '@/pages/Territory/ViewReport/ViewReport';
import type { RouteConfig } from '@/types/routestypes'
import React, { lazy, memo } from 'react'

const Territory = lazy(() => import("@/pages/Territory/Territory"));
const TerritoryMasterPage = lazy(() => import("@/pages/Territory/TerritoryMaster/TerritoryMaster"));
const BulkUploadPage = lazy(() => import("@/pages/Territory/BulkUpload/BulkUpload"));

const TerritoryMasterRoute: RouteConfig = {
    path: "territorymaster",
    pageName: "Territory Master",
    sidebar: { show: true, icon: "" },
    permission: ["TerritoryMaster"],
    element: < Territory />,
    children: {
        MAIN: {
            path: "",
            pageName: "Territory Master",
            element: <TerritoryMasterPage />,
            sidebar: { show: false, icon: "" },
        },
        BULK_UPLOAD: {
            path: "bulkupload",
            pageName: "BulkUpload",
            element: <BulkUploadPage />,
            sidebar: { show: false },
        },
        TERRITORY_MASTER_REPORT: {
            path: "report",
            element: <TerritoryMasterReport />,
            pageName: "Territory Master Report",
            sidebar: { show: false },
        },
        VIEW_REPORT: {
            path: "view/:fileId",
            element: <ViewTerritory />,
            pageName: "View Territory",
            sidebar: { show: false },
        },
    }
}

export default TerritoryMasterRoute
